import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import AppValues from 'src/app/common/app.values';
import { GridTableBody, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { ConnectionStatus } from 'src/app/swagger-api/model/connectionStatus';
import { CellActionTooltipValues, CellActionTypes } from '../../tables/components/cell-actions.type';
import { DoctorLink } from '../relation-request.interface';
import { DoctorLinkReceivedTable, DoctorLinkSentTable, DoctorLinkTable } from './doctor-link-tables';
import { RelationRequestTables } from './table-creator.enum';
import { RelationRequestTableFactory } from './user-relation-requests-table';

const linkedRequestTooltipValues: CellActionTooltipValues = {
  [CellActionTypes.REMOVE]: 'TOOLTIP_UNLINK_DOCTOR',
  [CellActionTypes.SEND_MSG]: 'TOOLTIP_SEND_MESSAGE',
};

const sentLinkRequestTooltipValues: CellActionTooltipValues = {
  [CellActionTypes.REMOVE]: 'TOOLTIP_REMOVE_REQUEST',
};

const receivedLinkRequestTooltipValues: CellActionTooltipValues = {
  [CellActionTypes.CONFIRM]: 'TOOLTIP_ACCEPT_REQUEST',
  [CellActionTypes.REJECT]: 'TOOLTIP_DECLINE_REQUEST',
};

export const doctorLinkRowData: (linkRequest: DoctorLink) => GridTableBody = (linkRequest: DoctorLink) => {
  const created: string =
    new DatePipe('en-US').transform(
      linkRequest.acceptanceDate || linkRequest.invitationDate,
      AppValues.DATE_FORMAT_SHORT,
    ) ?? '';

  return {
    entityId: linkRequest.entityId,
    actorId: linkRequest.relatedUser.user_id,
    user: linkRequest.relatedUser,
    list: linkRequest.specialties,
    manage: { status: true, reason: ConnectionStatus.Verified },
    tooltipValues: linkedRequestTooltipValues,
    created,
  };
};

export const doctorLinkReceivedRowData: (linkRequest: DoctorLink) => GridTableBody = (linkRequest: DoctorLink) => {
  return {
    ...doctorLinkRowData(linkRequest),
    manage: { status: null, reason: null },
    tooltipValues: receivedLinkRequestTooltipValues,
  };
};

export const doctorLinkSentRowData: (linkRequest: DoctorLink) => GridTableBody = (linkRequest: DoctorLink) => {
  return {
    ...doctorLinkRowData(linkRequest),
    manage: { status: true, reason: ConnectionStatus.Pending },
    tooltipValues: sentLinkRequestTooltipValues,
  };
};

@Injectable()
export class DoctorLinkTableFactory extends RelationRequestTableFactory<DoctorLink> {
  public buildTableConstructorData(type: RelationRequestTables, items: DoctorLink[]): UserTableConstructorInfo {
    switch (type) {
      case RelationRequestTables.DOCTOR_LINKED_REQUESTS:
        return new DoctorLinkTable().buildTableData(items);

      case RelationRequestTables.DOCTOR_SENT_LINK_REQUEST:
        return new DoctorLinkSentTable().buildTableData(items);

      case RelationRequestTables.DOCTOR_RECEIVED_LINK_REQUEST:
        return new DoctorLinkReceivedTable().buildTableData(items);
      default:
        return { header: [], body: [], attribute: null };
    }
  }
}
